import React from "react";
import "./Loader.css";

export const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};
export const BalanceLoading = () => {
  return (
   <div className="balanceLoading"></div>
   );
};